import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// ── Styles — ORDER IS LOAD-BEARING ───────────────────────────────────────────
// fonts.css declares the self-hosted @font-face set; klaxiora.css is the
// adopted S-Tier design system (all tokens + the .k-* contract) and MUST come
// before index.css, whose theme() references resolve through tokens.ts into
// those custom properties.
import './styles/fonts.css'
import './styles/klaxiora.css'
import './styles/pipeline.css'
import './styles/orgchart.css'
import './index.css'
import { TenantProvider } from './contexts/TenantContext'
import { isWorkOSAuth } from './api/client'
import { AuthProvider } from './auth/AuthProvider'
import { WorkOSGate } from './components/auth/WorkOSGate'
import App from './App'

const root = document.getElementById('root')
if (!root) throw new Error('#root element not found — check index.html')

// In workos mode the app is gated behind WorkOS AuthKit sign-in (AuthProvider +
// WorkOSGate). stub/jwt render App directly — App keeps its own paste-a-JWT gate
// for jwt mode, so those modes are unchanged.
const app = isWorkOSAuth() ? (
  <AuthProvider>
    <WorkOSGate>
      <App />
    </WorkOSGate>
  </AuthProvider>
) : (
  <App />
)

createRoot(root).render(
  <StrictMode>
    {/*
      TenantProvider wraps the entire tree so every component can call
      useTenant() without prop-drilling. The initialTenantId can be driven
      from a query-string param or env variable in production.
    */}
    <TenantProvider initialTenantId={import.meta.env.VITE_DEFAULT_TENANT ?? 'dev-tenant'}>
      {app}
    </TenantProvider>
  </StrictMode>,
)
